import { Entry } from '../Entry'

export function Entry20240522() {
  return (
    <Entry title="22/05/2023 - v3.7.3">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/15847/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
